// extracted by mini-css-extract-plugin
export default {"fullscreen":"Spinner_fullscreen__ax6fK"};